import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { authApi, isManager, MANAGER_ROLES, setTokens, clearTokens } from '../api/auth';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = sessionStorage.getItem('bit_token') || localStorage.getItem('bit_token');
    if (!token) { setUser(null); setLoading(false); return; }
    try {
      setUser(await authApi.me());
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const data = await authApi.login(email, password);
    setTokens(data);
    await refresh();
  };

  const logout = () => {
    clearTokens();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh, isManager: isManager(user) }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export { MANAGER_ROLES };
